// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer-module__root___1rOJo Fonts-module__at___1f_7n","menu":"Footer-module__menu___3R71Z","authors":"Footer-module__authors___teK2b"};